export enum StepTravelMode {
  Walking,
  Bus,
  Train,
  Ferry,
  Driving,
  Bicycling
}
